/**
 * Splits items into two arrays: active (not archived) and historical (archived).
 *
 * @param {Array<Object>} [items=[]] - Array of items to process. Each item should have an `isArchived` property.
 * @returns {[Array<Object>, Array<Object>]} - A tuple where the first element is the array of active items, and the second is the array of historical items.
 *
 */
const getHistoricalAndActiveItems = (items = []) => {
  if (!Array.isArray(items)) {
    return [[], []];
  }

  const activeItems = [];
  const historicalItems = items.filter((el) => {
    const { isArchived } = el || {};
    if (!isArchived) {
      activeItems.push(el);
      return false;
    }
    return true;
  });
  return [activeItems, historicalItems];
};

export default getHistoricalAndActiveItems;
